<app-job-invoices-retention [job]="job" (invoiceChange)="onInvoiceChange()" *ngIf="job.RetentionPercentage > 0">
</app-job-invoices-retention>

<fieldset class="panel panel-white padding-0">
    <div class="panel-heading border-light">
        <h4 class="panel-title">Invoices</h4>
        <ul class="panel-heading-tabs border-light">
            <li class="d-flex">
                <div class="input-wrapper">
                    <i class="prefix fa-light fa-magnifying-glass"></i>
                    <input [value]="searchText()" (input)="handleSearchInput($event)" class="text-input" placeholder="Search" />
                    <button
                        id="job-invoices-completion-percent-filter-search-reset"
                        class="suffix btn-flat btn-small square"
                        (click)="searchText.set('')">
                        <i class="fa-light fa-xmark"></i>
                    </button>
                </div>
            </li>
            <li>
                <div class="btn-group">
                    <button
                        type="button"
                        class="btn btn-bx-primary"
                        (click)="addInvoice()"
                        [disabled]="isEstimateNotAccepted()"
                        *ngIf="permissionService.isAvailable('jobs.maintain-invoices.create-invoice')">
                        <i class="ti-plus" tooltip="Add invoice" container="body"></i>
                    </button>
                </div>
            </li>
            <li>
                <div class="btn-group dropdown" dropdown>
                    <button type="button" class="btn btn-default dropdown-toggle" dropdownToggle aria-haspopup="true" aria-expanded="false">
                        <i class="ti-settings"></i> <span class="caret margin-left-5"></span>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-right no-max-height" role="menu" *dropdownMenu>
                        <li *ngIf="permissionService.isAvailable('jobs.maintain-invoices.manage-payment-terms')">
                            <a (click)="termsAndConditions()"><i class="ti-comment-alt"></i> Manage Payment Terms</a>
                        </li>
                        <li *ngIf="permissionService.isAvailable('jobs.maintain-invoices.print-email-invoice-statement')">
                            <a (click)="printJobClaim()"><i class="ti-printer"></i> Print Invoice Statement</a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <div class="panel-body">
        <div class="row" *ngIf="!isEstimateNotAccepted()">
            <div class="col-xs-12">
                <div class="btn-group btn-group-xs" role="group">
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'All' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('All')">
                        All <span class="badge badge-light-grey">{{ invoiceCounts().all }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Pending' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Pending')">
                        Pending <span class="badge badge-light-grey">{{ invoiceCounts().pending }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Invoiced' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Invoiced')">
                        Invoiced <span class="badge badge-light-grey">{{ invoiceCounts().invoiced }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'PartReceived' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('PartReceived')">
                        Part Received <span class="badge badge-light-grey">{{ invoiceCounts().partreceived }}</span>
                    </button>
                    <button
                        type="button"
                        class="mr-1"
                        [ngClass]="statusFilter() !== 'Received' ? 'btn-bx-secondary-stroked' : 'btn-bx-secondary'"
                        (click)="statusFilter.set('Received')">
                        Received <span class="badge badge-light-grey">{{ invoiceCounts().received }}</span>
                    </button>
                </div>
                <div class="form-group form-inline pull-right margin-right-5">
                    <label>Default due days:</label>
                    <input
                        legacy-css
                        class="form-control margin-left-5"
                        type="number"
                        min="0"
                        max="365"
                        required
                        [(ngModel)]="job.InvoiceDueDays"
                        (change)="saveJob()"
                        [ngModelOptions]="{ standalone: true }"
                        appNullReplace="14" />
                </div>
            </div>
        </div>

        <div class="col-xs-12 text-center" *ngIf="isEstimateNotAccepted()">
            <h2 class="margin-top-30 margin-bottom-30">
                You're still working on your estimate.<br />Once it's accepted, you'll be able to create invoices.
            </h2>
            <p class="text-normal">You can't create invoices/claims for categories that can still possibly change.</p>
        </div>
        <div
            class="col-xs-12 text-center"
            *ngIf="
                invoiceCounts().all == 0 &&
                !isEstimateNotAccepted() &&
                permissionService.isAvailable('jobs.maintain-invoices.create-invoice')
            ">
            <h2 class="margin-top-30 margin-bottom-30">Click the + button above to add a new invoice</h2>
        </div>

        <div class="form-group">
            <div class="table-wrapper">
                <ngx-datatable
                    [ngStyle]="{ height: tableHeight }"
                    #invoicesTable
                    class="material bxt-table"
                    *ngIf="rows()?.length"
                    [rows]="rows()"
                    [rowHeight]="40"
                    columnMode="force"
                    [scrollbarV]="true"
                    cdkDropList
                    [headerHeight]="50"
                    [footerHeight]="0"
                    [sorts]="[{ prop: 'InvoiceDate', dir: 'desc' }]"
                    [virtualization]="false"
                    [limit]="100">
                    <!-- columns -->
                    <ngx-datatable-column name="Invoice #" [flexGrow]="1" [minWidth]="95" prop="InvoiceNumberString">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a [class.bxt-row-action]="row.InvoiceNumber !== 0" (click)="viewInvoice(row)">
                                {{ row.InvoiceNumberString }}
                                <i
                                    *ngIf="row.AccSyncData && row.AccSyncData !== 'blocked'"
                                    class="ti-cloud-up"
                                    tooltip="Synced to your accounting software"
                                    container="body"></i>
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Description" [flexGrow]="8" prop="Description">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <a class="bxt-row-action" (click)="viewInvoice(row)">
                                {{ row.Description }}
                            </a>
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Invoiced" [flexGrow]="2" prop="InvoiceDate">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.InvoiceDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Due" [flexGrow]="2" prop="DueDate">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.DueDate | date }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Contract (Ex)" [flexGrow]="2" prop="PaymentValue">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.InvoiceContractLessRetentionAmount - row.Adjustment | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column [name]="translations.variationsExTitle" [flexGrow]="2" prop="VariationsValue">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.InvoiceVariationLessRetentionAmount | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Total (Ex)" [flexGrow]="2" prop="Total">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.Total + row.Adjustment | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Balance (Inc)" [flexGrow]="2" *ngIf="filter === 'PartReceived'" prop="BalanceTotalIncTax">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            {{ row.BalanceTotalIncTax | bxCurrency }}
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column name="Status" [flexGrow]="2" prop="Status">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <span
                                class="label"
                                [ngClass]="{
                                    'label-inverse': row.Status === 'Pending',
                                    'label-warning': row.Status === 'Invoiced',
                                    'label-info': row.Status === 'PartReceived',
                                    'label-success': row.Status === 'Received',
                                }"
                                >{{ row.Status }}</span
                            >
                        </ng-template>
                    </ngx-datatable-column>
                    <ngx-datatable-column
                        [width]="180"
                        [sortable]="false"
                        [canAutoResize]="false"
                        [draggable]="false"
                        [resizeable]="false"
                        [cellClass]="'right-align'"
                        [headerClass]="'disabled'">
                        <ng-template let-row="row" ngx-datatable-cell-template>
                            <button
                                type="button"
                                class="btn btn-xs btn-info margin-left-5"
                                (click)="addReceipt(row)"
                                tooltip="Add Payment Receipt"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="
                                    permissionService.isAvailable('jobs.maintain-invoices.add-payment-receipt') &&
                                    (row.Status === 'Invoiced' || row.Status === 'PartReceived')
                                ">
                                <i class="ti-receipt"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-default margin-left-5"
                                (click)="shareInvoice(row)"
                                tooltip="Share"
                                container="body"
                                [adaptivePosition]="false">
                                Share
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-default margin-left-5"
                                (click)="printInvoice(row)"
                                tooltip="Print"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="permissionService.isAvailable('jobs.maintain-invoices.print-email-invoice')">
                                <i class="ti-printer"></i>
                            </button>
                            <button
                                type="button"
                                class="btn btn-xs btn-danger margin-left-5"
                                (click)="deleteInvoice($event, row)"
                                [disabled]="row.Status !== 'Pending'"
                                tooltip="Delete"
                                container="body"
                                [adaptivePosition]="false"
                                *ngIf="permissionService.isAvailable('jobs.maintain-invoices.delete-invoice')">
                                <i class="ti-trash"></i>
                            </button>
                        </ng-template>
                    </ngx-datatable-column>
                </ngx-datatable>
            </div>
        </div>
    </div>
</fieldset>
